import { useState } from "react"
import twemoji from "twemoji"
import type { StarInfoResponse } from "@/service/api/info"
import { Typography } from "@/components/Typography"
import placeholderLogo from "@/assets/images/logo/ProfileDefault.png"

interface Props {
  starInfo?: StarInfoResponse
}

const Profile = ({ starInfo }: Props) => {
  const { coverImageUrl, profileUrl, name, profileMessage } = starInfo ?? {}
  const [isLoaded, setIsLoaded] = useState(false)
  const [hasError, setHasError] = useState(false)

  const decodeUnicode = (str: string) => {
    try {
      return JSON.parse(`"${str}"`)
    } catch (e) {
      console.warn("디코딩 실패:", e)
      return str
    }
  }

  const emojiString = decodeUnicode(profileMessage ?? "")
  const html = twemoji.parse(emojiString, {
    folder: "svg",
    ext: ".svg",
    base: "https://cdnjs.cloudflare.com/ajax/libs/twemoji/14.0.2/",
  })

  return (
    <div
      className="flex relative flex-col w-full bg-center bg-no-repeat bg-cover h-"
      style={{ backgroundImage: `url(${coverImageUrl})` }}
    >
      <div className="relative w-full h-80 bg-center bg-cover">
        <div className="absolute left-1/2 bottom-0 translate-x-[-50%] translate-y-1/2">
          {/* placeholder */}
          <img
            src={placeholderLogo}
            alt="placeholder"
            className={`${
              isLoaded ? "opacity-0" : "opacity-50 grayscale"
            } size-24 border-2 border-white rounded-[28px] transition-opacity duration-300`}
            loading="eager"
          />

          {/* 실제 profile Image */}
          <img
            src={profileUrl}
            onLoad={() => setIsLoaded(true)}
            onError={() => {
              setHasError(true)
              setIsLoaded(true)
            }}
            className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-500 border-2 border-white rounded-[28px] ${
              isLoaded && !hasError ? "opacity-100" : "opacity-0"
            }`}
            loading="eager"
          />
        </div>
      </div>

      <div className="flex flex-col gap-1 px-4 pb-6 bg-white pt-13 rounded-t-4xl">
        <Typography variant="h4">{name}</Typography>
        <div
          className="[&_.emoji]:inline-block [&_.emoji]:w-[1.2em] [&_.emoji]:h-[1.2em] [&_.emoji]:align-middle text-sm leading-5 font-normal tracking-[-0.03em] align-middle"
          dangerouslySetInnerHTML={{ __html: html }}
        />
      </div>
    </div>
  )
}

export default Profile
